var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "card text-white", attrs: { href: "#" } }, [
      _c("img", {
        staticClass: "card-img d-none d-lg-block",
        attrs: { src: "/images/temp/promo_bg.png", alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card-img-overlay mobile-list" }, [
        _c(
          "div",
          { staticClass: "d-lg-block d-flex flex-row justify-content-between" },
          [
            _c("h2", { staticClass: "card-title" }, [
              _c("span", [_vm._v("Wcześniej taniej!")]),
              _vm._v("\n        10% - 30%\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "btn btn-warning link d-none d-lg-block stretched-link",
              },
              [_vm._v("Więcej")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "btn btn-sm btn-primary link d-lg-none align-self-center btn-icon-arrow",
              },
              [_c("i", { staticClass: "bi bi-arrow-right mx-3" })]
            ),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }